/**
 * Component: Quickview script
 * ------------------------------------------------------------------------------
 * An example file that contains scripts to function.
 *
 * @namespace Quickview
 */

import axios from 'axios';
import Cookies from 'js-cookie';
import {enableBodyScroll} from 'body-scroll-lock';
import {on} from '../helpers/utils';
import PanGlobalStock from '../components/pan-global-stock';
import ProductQuickviewForm from '../components/product-quickview-form';
import ProductGallery from '../components/product-gallery';
import Carousel from '../components/carousel';
import Modal from '../components/modal';

/**
 * DOM selectors.
 */
const selectors = {
  quickviewSelector: '[js-quickview="toggle"]',
  quickviewParent: '[js-quickview="body"]',
  quickviewCardWrapper: '[js-quickview="card-wrapper"]',
  quickviewLoader: '[js-quickview="loader"]',
};

/**
 * Create a new example object.
 * @param {object} config - Settings object defined when instantiating.
 */
export default () => {
  let quickviewModal = {};

  /**
   * DOM node selectors.
   */
  const nodeSelectors = {
    quickviewSelector: document.querySelector(selectors.quickviewSelector),
    quickviewParent: document.querySelector(selectors.quickviewParent),
    quickviewCardWrapper: document.querySelector(selectors.quickviewCardWrapper),
    quickviewLoader: document.querySelector(selectors.quickviewLoader),
  };

  /**
   * Initialise component.
   */
  function init() {
    setTriggerEvents();
    constructModal();
    setEventBusListeners();
  }

  function constructModal() {
    quickviewModal = new Modal('quickview-modal', {
      onClose() {
        enableBodyScroll(document.querySelector('#quickview-modal .modal__card'));
      },
    });
    Frame.EventBus.listen('AjaxCart:itemAdded', () => {
      quickviewModal.close();
    });
  }

  function setEventBusListeners() {
    Frame.EventBus.listen('Nosto:rendered', setTriggerEvents);
  }

  /**
   * iWish app click event handler
   */
  function iWishEventHandler() {
    /* eslint-disable */ 
    jQuery(document).ready(() => {
      jQuery("a[href='/apps/iwish']").click((e) => {
        if (typeof (Storage) !== 'undefined') {
          e.preventDefault();
          iWishPost('/apps/iwish', {iwishlist: JSON.stringify(iWishlistmain), cId: iwish_cid});
        }
      });
      jQuery('.iWishAdd').click(function() {
        const iWishvId = jQuery(this).parents(iwishWrapperClass).find(iWishVarSelector)
.val();
        iwish_add(jQuery(this), iWishvId);
        return false;
      });
      jQuery('.iWishAddColl').click(function() {
        const iWishvId = jQuery(this).attr('data-variant');
        iwish_addCollection(jQuery(this), iWishvId);
        return false;
      });
      iwishCheckColl();
    });
    /* eslint-enable */
  }

  /**
   * - Fetches product handle attribute for quickview function
   * - checks for js-product-url attribute for nosto elements which can't supply product handle
   * @param {element} target - target dom element from event listener
   */
  function getProductHandleAttribute(element) {
    const handleAttribute = element.getAttribute('js-product-handle');
    const urlAttribute = element.getAttribute('js-product-url');
    return handleAttribute ? handleAttribute : productUrlToHandle(urlAttribute);
  }

  function productUrlToHandle(url) {
    if (!url) {
      return null;
    }
    const handleWithQuery = url.split('/').pop();
    const handleWithoutQuery = handleWithQuery.split('?')[0];
    return handleWithoutQuery;
  }

  /**
   * Set trigger listeners.
   */
  function setTriggerEvents() {
    const quickviewParents = [...document.querySelectorAll(selectors.quickviewParent)];
    quickviewParents.forEach((quickviewParentElement) => {
      on('click', quickviewParentElement, handleQuickviewClick);
    });
  }

  function handleQuickviewClick(event) {
    const quickviewAttribute = event.target.attributes['js-quickview'];
    if (!quickviewAttribute || quickviewAttribute.value !== 'toggle') { return; }

    event.preventDefault();
    quickviewModal.show();

    const productHandle = getProductHandleAttribute(event.target);

    axios.get(`${theme.routes.rootUrl}/products/${productHandle}?view=quickview`)
      .then((response) => {
        nodeSelectors.quickviewCardWrapper.innerHTML = response.data;

        window.dispatchEvent(new CustomEvent('blubolt:quickviewLoaded', {detail: productHandle}))

        PanGlobalStock().init();

        ProductQuickviewForm({
          container: 'quickview-container',
          enableSwatches: true,
          enableHistoryState: false,
        }).init();

        iWishEventHandler();

        ProductGallery({
          container: 'quickview-container',
        }).init();

        Carousel('[js-quickview="gallery"] .product-gallery__thumbnails-nav', {
          prevNextButtons: true,
          cellSelector: '.product-gallery__thumbnail',
        }).init();

        if (theme.features.currencyConverter) {
          Frame.MultiCurrency.CurrencyConverter.convertAll(Cookies.get('new_currency'));
        }

        // Frame.appendUrlParams.updateLinkParams();

        return response;
      }).catch((error) => {
        console.log(error);
      });
  }

  /**
   * Expose public interface.
   */
  return Object.freeze({
    init,
  });
};
